export default "__VITE_ASSET__BEeZt4____"